import React, {
  useState,
  useEffect,
} from "react"

import SectionContainer from '../../SectionContainer'
import ButtonFilled from '../../ButtonFilled'
import SignIn from '../../SignIn'
import AdaptiveLink from '../../AdaptiveLink'


import styles from './styles.module.styl'

import Burger from '../../../assets/svg/burger.svg'
import IconClose from '../../../assets/svg/iconClose.svg'
import Logotype from '../../../assets/svg/site-horizontal.svg'

import sectionData from '../../../pages-data/index/header'
import Chevron from '../../../assets/svg/chevron.svg'


export default function SectionHeader(props) {

  const [ mobileHeaderExpanded, setMobileHeaderExpandState ] = useState(false)

  const [ menuState, setMenuState ] = useState('main')

  const currentItem = menuState !== 'main'
    ? sectionData.menuItems[sectionData.menuItems.findIndex(element => element.main.href === menuState)]
    : null

  const showSubmenu = function(id) {
    document.getElementById(id).style.display = 'flex'
  }

  const hideSubmenu = function(id) {
    document.getElementById(id).style.display = 'none'
  }

  const renderCapabilityCaption = item => (
    <>
      { item.main.text }

      {
        item.additionalLinks &&
        <Chevron className={styles.header__subLinkMenu_chevron}/>
      }
    </>
  )




  useEffect(() => {
    if (typeof window !== 'undefined') {
      window.addEventListener('scroll', onScrollHandler)

      return () => {
        window.removeEventListener('scroll', onScrollHandler)
      }
    }

    function onScrollHandler() {
      const header = document.getElementById('header')
      const className = `
        ${styles.headerContainer}
        ${mobileHeaderExpanded ? styles.__expand : ''}
      `

      header.className = `${className} ${styles.__shadow}`

      if (window.pageYOffset === 0) {
        header.className = className
      }
    }
  })

  // Присваивание для body класса, запрещающего скрол при "раскрытом" хидере
  // на мобильных устройствах.
  useEffect(() => {

    // Для корректного отображения в браузере Safari свойство overflow:hidden, присутствующее в
    // классе 'headerExpanded', нужно задавать не элементу body, а элементу-обёртке, имимтирующему
    // элемент body. В нашем случае это элемент <main>:
    const main = document.getElementsByTagName('main')[0]

    // метод `replace` не использую, потому что он в IE 11 не поддерживается
    if (mobileHeaderExpanded) {
      document.body.classList.add(styles.headerExpanded)
      main.classList.add(styles.headerExpanded)
    }
    else {
      document.body.classList.remove(styles.headerExpanded)
      main.classList.remove(styles.headerExpanded)
    }

    // сбрасываем эффект при размонтировании, т.е. удаляем классы:
    return function() {
      document.body.classList.remove(styles.headerExpanded)
      main.classList.remove(styles.headerExpanded)
    }
  })

  const renderStartButton = () => (
    <ButtonFilled
      className={styles.header__startButton}
      href={sectionData.startButton.href}
      useGatsbyLink={sectionData.startButton.useGatsbyLink}
      colorType='blue'
    >
      {sectionData.startButton.text}
    </ButtonFilled>
  )

  return (

    <div className={styles.headerPlaceholder}>
      <SectionContainer
        id={'header'}
        className={`
        ${styles.headerContainer}
        ${mobileHeaderExpanded ? styles.__expand : ''}
      `}
      >
        <header className={styles.header}>

          <div className={styles.header__leftBlock}>

            {
              props.indexPage
                ? <Logotype className={styles.header__logoLink}/>
                : <AdaptiveLink
                  className={styles.header__logoLink}
                  href={sectionData.indexPage.href}
                  useGatsbyLink={sectionData.indexPage.useGatsbyLink}
                >
                  <Logotype className={styles.header__logoLink}/>
                </AdaptiveLink>
            }

            <div
              className={styles.header__burger}
              onClick={ () => {
                setMobileHeaderExpandState(!mobileHeaderExpanded)
              }}
            >
              {mobileHeaderExpanded === true ? <IconClose /> : <Burger />}
            </div>

            {renderStartButton()}

          </div>

          <div className={styles.header__centerBlock}>

            <nav className={styles.header__menu}>

              {
                menuState === 'main'
                  ? sectionData.menuItems.map(
                      item => (
                        <div
                          onMouseEnter={() => showSubmenu(item.main.href)}
                          onMouseLeave={() => hideSubmenu(item.main.href)}
                          className={styles.header__menuItemWrapper}
                          key={item.main.href}
                        >

                          <span className={styles.hideDesktop__inline}>
                            {
                              item.additionalLinks
                                ?
                                <a
                                  className={styles.header__menuItem}
                                  onClick={() => mobileHeaderExpanded && setMenuState(item.main.href)}
                                >
                                  { renderCapabilityCaption(item) }
                                </a>
                                :
                                <AdaptiveLink
                                  className={styles.header__menuItem}
                                  href={item.main.href}
                                  useGatsbyLink={item.main.useGatsbyLink}
                                >
                                  { renderCapabilityCaption(item) }
                                </AdaptiveLink>
                            }
                          </span>

                          <AdaptiveLink
                            className={`${styles.header__menuItem} ${styles.hideMobile}`}
                            href={item.main.href}
                            useGatsbyLink={item.main.useGatsbyLink}
                          >
                            { renderCapabilityCaption(item) }
                          </AdaptiveLink>

                          {
                            item.additionalLinks &&
                            <Chevron
                              className={styles.header__subLinkMenu_chevron_mobile}
                              onClick={() => setMenuState(item.main.href)}
                            />
                          }

                          <div
                            itemScope
                            itemType='https://schema.org/SiteNavigationElement'
                            className={styles.header__subLinkMenu}
                            id={item.main.href}
                          >
                            {
                              item.additionalLinks &&
                              item.additionalLinks.map(
                                subItem =>
                                  <AdaptiveLink
                                    itemprop='url'
                                    href={subItem.link.href}
                                    key={subItem.link.href + subItem.link.description}
                                    useGatsbyLink={subItem.link.useGatsbyLink}
                                    className={`
                                    ${styles.header__subLinkMenu_item}
                                    ${
                                      subItem.link.href === '/capability/'
                                        ? styles.capability
                                        : ''
                                    }
                                    `}
                                  >
                                    { subItem.icon }

                                    { subItem.link.description || subItem.link.text }
                                  </AdaptiveLink>
                              )
                            }
                          </div>
                        </div>
                      )
                    )
                  : <div className={styles.header__subLinkMenu_mobile}>

                      <div
                        className={styles.header__subLinkMenu_header_mobile}
                        onClick={() => setMenuState("main")}
                      >
                        <Chevron
                          className={`
                            ${styles.header__subLinkMenu_chevron_mobile}
                            ${menuState !== 'main' ? styles.open : ''}
                          `}
                        />
                        {currentItem.main.text}
                      </div>

                      <div id={currentItem.main.href}>
                        {
                          currentItem.additionalLinks.map(
                            subItem =>
                              <AdaptiveLink
                                href={subItem.link.href}
                                key={subItem.link.href}
                                useGatsbyLink={subItem.link.useGatsbyLink}
                                className={`
                                  ${styles.header__subLinkMenu_item}
                                  ${subItem.link.href === '/capability/'
                                        ? styles.capability
                                        : ''
                                    }
                                `}
                              >
                                { subItem.icon }

                                { subItem.link.description || subItem.link.text }
                              </AdaptiveLink>
                          )
                        }
                      </div>
                    </div>
                }
            </nav>

            { menuState === 'main' && renderStartButton() }

            <SignIn className={styles.hideDesktop__flex}/>

          </div>

          <div className={styles.header__rightBlock}>

            <AdaptiveLink
              className={styles.header__license}
              href={sectionData.license.href}
              useGatsbyLink={sectionData.license.useGatsbyLink}
            >
              {sectionData.license.text}
            </AdaptiveLink>

            <a
              className={styles.header__phone}
              href={`tel:${sectionData.phone.value}`}
            >
              {sectionData.phone.text}
            </a>

            {renderStartButton()}

            {/*TODO Здесь нужен компонент с аватаркой пользователя*/}
            <SignIn className={styles.hideMobile}/>

            <AdaptiveLink
              className={styles.header__confidentiality}
              href={sectionData.confidentiality.href}
              useGatsbyLink={sectionData.confidentiality.useGatsbyLink}
            >
              {sectionData.confidentiality.text}
            </AdaptiveLink>

          </div>

        </header>
      </SectionContainer>
    </div>

  )

}
